import { Component, OnInit, Input } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NavigationService } from 'src/app/navigation/navigation.service';
import { GamesService } from 'src/app/gamification/command-center/services/games.service';
import { ConfigureEstimatorPopupComponent } from '../configure-estimator-popup/configure-estimator-popup.component';

@Component({
  selector: 'cv-configure-estimator',
  templateUrl: './configure-estimator.component.html',
  styleUrls: ['./configure-estimator.component.scss']
})
export class ConfigureEstimatorComponent implements OnInit {
  @Input() step: number;
  @Input() componentOptions: any;

  gs: any = null;
  schedule: any;
  consideredComplete: boolean = false;

  constructor(
    private modalService: NgbModal,
    private gamesService: GamesService,
    private navigationService: NavigationService,
  ) { 
    this.gs = this.gamesService.data;
    this.schedule = this.gs.modified.item.Schedule;
  }

  ngOnInit(): void {
  }

  openMetricModal(){
    this.navigationService.showOverlay = true;
    const modalRef = this.modalService.open(ConfigureEstimatorPopupComponent, {
      animation: true,
      backdrop: 'static',
      backdropClass: 'stopScrolling',
      size: 'xl modal-dialog-noborder-when-loading modal-dialog-centered',
    });
    modalRef.componentInstance.isRaffle = this.componentOptions.isRaffle;

    modalRef.result.then(() => {
      this.navigationService.showOverlay = false;
    });
  }
}